export const DEFAULT_AI_STUDENT_NAME = 'Alex';
export const DEFAULT_AI_STUDENT_DESCRIPTION = 'A curious classmate who joins group discussions with their own tentative ideas and builds on what others say.';
